import { useMsal } from "@azure/msal-react";
import { useState } from "react";
import { Outlet } from "react-router-dom";

import TourGuide from "@/Components/TourGuide";
import Navbar from "@/features/Navbar/Navbar";
import Footer from "@/Pages/Footer";

const COLLAPSED_WIDTH = 64;
const EXPANDED_WIDTH = 300;

export default function MainLayout() {
  const [drawerOpen, setDrawerOpen] = useState(false);

  const { accounts } = useMsal();

  const userPrincipalName =
    (accounts[0]?.idTokenClaims as any)?.preferred_username || accounts[0]?.username || "";

  const [notifications] = useState<any[]>([]);
  const unreadTotal = notifications.filter((n) => !n.read).length;

  return (
    <div className="flex min-h-screen flex-col">
      <Navbar
        drawerOpen={drawerOpen}
        setDrawerOpen={setDrawerOpen}
        notifications={notifications}
        unreadTotal={unreadTotal}
        onRestartTour={() => window.dispatchEvent(new CustomEvent("restart-tour"))}
      />

      <TourGuide userPrincipalName={userPrincipalName} />

      <main
        className="flex-1 pt-14 transition-all duration-300 bg-[rgb(246,244,239)]"
        style={{
          marginLeft: drawerOpen ? `${EXPANDED_WIDTH}px` : `${COLLAPSED_WIDTH}px`,
        }}
      >
        <Outlet />
      </main>

      <Footer />
    </div>
  );
}
